var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main"},[_c('img',{staticClass:"left",attrs:{"src":require("../assets/xxdj_btn1@2x.png"),"alt":""},on:{"click":_vm.jumpOne}}),_c('img',{staticClass:"right",attrs:{"src":require("../assets/xxdj_btn2@2x.png"),"alt":""},on:{"click":_vm.junpTwo}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }